export const positions = ['top', 'right', 'bottom', 'left'] as const
